import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';
import { SvcUserPickerComponent } from './svc-user-picker.component';
import { SvcUserAvatarModule } from '@solvace/component/svc-user-avatar';
import { SvcControlsModule } from '@solvace/component/svc-controls';

@NgModule({
  declarations: [
    SvcUserPickerComponent,
  ],
  imports: [
    LibSharedCommonModule,
    SvcUserAvatarModule,
    SvcControlsModule,
    TranslocoModule,
  ],
  exports: [
    SvcUserPickerComponent,
  ],
})
export class SvcUserPickerModule { }
